export default __webpack_public_path__ + "static/media/image-work-personal-w@2x.427cb664.png";